export { createGlobalConfig } from './global-config';
export type { GlobalConfig } from './global-config';
